module.exports = __webpack_public_path__ + "img/ALSi6-Numerics.43421e7b.png";